import React, { FC, useRef, useState } from 'react';

import { Play, Stop } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import clx from 'classnames';

import styles from './Resources.module.scss';

export const AudioControl: FC<{
    src: string;
}> = ({ src }) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [error, setError] = useState(false);

    const handlePlay = () => {
        if (audioRef.current) {
            audioRef.current.play().catch(() => {
                setError(true);
            });
            setIsPlaying(true);
        }
    };

    const handleStop = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsPlaying(false);
        }
    };

    const handleTogglePlay = () => {
        setError(false);
        if (isPlaying) {
            handleStop();
        } else {
            handlePlay();
        }
    };

    const handleAudioEnd = () => {
        setIsPlaying(false);
    };

    const handleAudioPause = () => {
        setIsPlaying(false);
    };

    return (
        <div className={styles.audioControl__container}>
            <audio
                ref={audioRef}
                onEnded={handleAudioEnd}
                onPause={handleAudioPause}
                onError={() => setError(true)}
                controlsList="nodownload"
                preload="none"
            >
                <source src={src} type="audio/ogg; codecs=opus" />
            </audio>
            <Button
                onClick={handleTogglePlay}
                size="xl"
                view="flat"
                className={clx(styles.audioControl__button, error && styles.audioControl__button_error)}
            >
                <div className={styles.audioControl__buttonContent}>
                    <Icon data={isPlaying ? Stop : Play} size={18} />
                </div>
            </Button>
        </div>
    );
};
